import { NgModule } from "@angular/core";

import { sharedModule } from "../shared/shared.module";
import { coreRoutingModule } from "./core-routing.module";
import { MenuComponent } from "../components/menu/menu.component";
import { HeaderComponent } from "../components/header/header.component";
import { MainLayoutComponent } from "./main-layout/main-layout.component";
import { OptionsComponent } from "../components/options/options.component";
import { SidebarComponent } from "../components/sidebar/sidebar.component";
import { DashboardComponent } from "../pages/dashboard/dashboard.component";
import { BreadcrumbComponent } from "../components/breadcrumb/breadcrumb.component";
import { PageNotFoundComponent } from "../pages/page-not-found/page-not-found.component";
import { NotificationComponent } from "../components/notification/notification.component";
import { ChooseBranchEntryComponent } from "./choose-branch-entry/choose-branch-entry.component";
import { ChooseBranchForUserComponent } from "../components/choose-branch-for-user/choose-branch-for-user.component";
import { MainLayoutStudentComponent } from './main-layout-student/main-layout-student.component';
import { StudentHeaderComponent } from "../components/student-header/student-header.component";
import { MainLayoutSubsidiaryComponent } from './main-layout-subsidiary/main-layout-subsidiary.component';
import { QuickSearchCoursesComponent } from './quick-search-courses/quick-search-courses.component';
import { RouteGuideComponent } from "../components/route-guide/route-guide.component";

@NgModule({
  declarations: [
    PageNotFoundComponent,
    DashboardComponent,
    HeaderComponent,
    MenuComponent,
    NotificationComponent,
    OptionsComponent,
    SidebarComponent,
    MainLayoutComponent,
    BreadcrumbComponent,
    ChooseBranchEntryComponent,
    ChooseBranchForUserComponent,
    MainLayoutStudentComponent,
    StudentHeaderComponent,
    MainLayoutSubsidiaryComponent,
    QuickSearchCoursesComponent,
    RouteGuideComponent
  ],
  imports: [sharedModule],
  exports: [coreRoutingModule,HeaderComponent],
  entryComponents: [ChooseBranchEntryComponent, QuickSearchCoursesComponent, RouteGuideComponent]
})
export class coreModule {}
